/**
 * Configuración central para temporizadores y formato de tiempo
 * 
 * @author Ana Lizcano
 */

export const TEST_CONFIG = {
  TEST_DURATION_MINUTES: 40,
  WARNING_TIME_MINUTES: 5,
  CRITICAL_TIME_MINUTES: 1,
  AUTO_SAVE_INTERVAL_SECONDS: 30,
  TIME_FORMAT: {
    SHOW_SECONDS: true,
    SHOW_HOURS: false
  }
};

export const getTestDurationMs = () => {
  return TEST_CONFIG.TEST_DURATION_MINUTES * 60 * 1000;
};

export const getWarningTimeMs = () => {
  return TEST_CONFIG.WARNING_TIME_MINUTES * 60 * 1000;
};

export const getCriticalTimeMs = () => {
  return TEST_CONFIG.CRITICAL_TIME_MINUTES * 60 * 1000;
};

export const formatTimeRemaining = (timeRemainingMs) => {
  const totalSeconds = Math.floor(timeRemainingMs / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  
  if (TEST_CONFIG.TIME_FORMAT.SHOW_SECONDS) {
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  } else {
    return `${minutes} min`;
  }
};

export const getTimerColor = (timeRemainingMs) => {
  if (timeRemainingMs <= getCriticalTimeMs()) {
    return '#d32f2f';
  } else if (timeRemainingMs <= getWarningTimeMs()) {
    return '#f57c00';
  } else {
    return '#667eea';
  }
};